
/*
    Context object for the whole app
*/

import React from "react";

const MainContext = React.createContext({});

export default MainContext;